import React from 'react'
import FormulaButton from '../formulaButton'
import SolidRateForm from '../../container/solidRateForm'

export default class SolidRateButton extends React.Component {
    render() {
        return (
            <div>
                <FormulaButton label="Solid Fraction" iconName="solidRate">
                    <SolidRateForm />
                </FormulaButton>
            </div>
        )
    }
}